<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/basic/work/procedure/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('gongxubianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')">
            <el-input v-model="yt.conditions.desc"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="yt.loading" @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button :loading="yt.loading" @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi')
              }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary"
          v-if="utils.checkPower('web_base_process_create')">
          {{ $t('xinzeng') }}
        </el-button>

        <el-button size="mini" @click="show = !show" type="primary" v-if="utils.checkPower('web_base_process_create')">
          {{ $t('daorugongxuchanpindanjia') }}
        </el-button>

        <el-button type="warning" v-if="utils.checkPower('web_report_export_chanpingdanjiashezhi_export')" size="mini"
          @click="exportExcel()">
          {{ $t('daochugongxuchanpindanjia') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->

      <template #buttonsR>
        <el-button v-if="utils.checkPower('web_base_process_work_procedure_material_price_export')" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"
          @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)"
              v-if="utils.checkPower('web_base_process_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('yonghudanjiashezhi', scope.row, '65%')"
              v-if="utils.checkPower('web_base_process_user_price_page')">{{ $t('yonghudanjiashezhi') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chanpindanjiashezhi', scope.row, '65%')">{{
      $t('chanpindanjiashezhi') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading"
              @click="yt.remove(scope.row, '/web/craft/basic/work/procedure/delete')"
              v-if="utils.checkPower('web_base_process_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongxubianma')" required="required">
            <el-input v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')" required="required">
            <el-input v-model="yt.editObj.desc"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjia(yuan)')">
            <el-input-number :precision="4" :min="0" v-model="yt.editObj.price"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/craft/basic/work/procedure/create', null, fetchData)"
            :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongxubianma')" required="required" class="noborder">
            <el-input disabled v-model.trim="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongxumiaoshu')" required="required">
            <el-input v-model="yt.editObj.desc"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danjia(yuan)')">
            <el-input-number :precision="4" :min="0" v-model="yt.editObj.price"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/craft/basic/work/procedure/update', null, fetchData)"
            :loading="yt.editObj.loading" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 用户单价设置 -->
      <template v-if="yt.editObj.action === 'yonghudanjiashezhi'">
        <div class="dialog-scroller">
          <user-price :workProcedure="yt.editObj"></user-price>
        </div>
      </template>
      <!-- 产品单价设置-->
      <template v-if="yt.editObj.action === 'chanpindanjiashezhi'">
        <div class="dialog-scroller">
          <product_price :workProcedure="yt.editObj"></product_price>
        </div>
      </template>
    </el-dialog>

    <importPrice :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import userPrice from './user_price'
import product_price from '@@/pages/web/base/process/product_price'
import importPrice from './import'
export default {
  name: 'web_base_process_list',
  components: {
    userPrice,
    product_price,
    importPrice
  },
  data() {
    return {
      show: false,
      columns: [
        {
          label: 'gongxubianma',
          prop: 'code',
          width: 180
        },
        {
          label: 'gongxumiaoshu',
          prop: 'desc',
          width: 180
        },
        {
          label: 'danjia(yuan)',
          prop: 'price',
          width: 150
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 180
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 300,
          fixed: 'right'
        }
      ]
    };
  },

  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    exportExcel() {
      let params = { ...this.yt.conditions };
      params.orderBy = "execution_month,code desc";
      return this.http
        .get('/web/report/export/work_procedure_material_price_export', { params })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    }
  }
};
</script>
